let elements = {
  // mainImage: {
  //   imagePath: 'games/page999_game112/img/paint.png',
  //   pos: {
  //     y: 0,
  //     x: 0,
  //   },
  // },
  stepper: {
    show: false,
    color: 'blue',
    orientation: 'bottom',
  },
  withoutCheck: true,
  steps: [
    {
      imagePath: 'games/page002_game4/img/i5.png',
      pos: {
        y: 0,
        x: 0,
      },
      width: 1920,
      height: 1080,
      controll: {
        text: '',
        type: 'next',
        pos: {
          y: 693,
          x: 335,
        },
        width: 56,
        height: 56,
        background: 'rgba(255,0,0,0)',
      },
    },
    {
      imagePath: 'games/page002_game4/img/i4.png',
      pos: {
        y: 0,
        x: 0,
      },
      width: 1920,
      height: 1080,
      controll: {
        text: '',
        type: 'prv',
        pos: {
          y: 693,
          x: 335,
        },
        width: 56,
        height: 56,
        background: 'rgba(255,0,0,0)',
      },
    },
  ],
};

export default elements;
